const styles = {
  alert: {
    backgroundColor: '#FFEBEE',
    padding: '4px 12px',
    '& .MuiAlert-message': {
      color: '#0C172C',
      fontFamily: "'Proxima Nova', sans-serif",
    },
    '& .MuiAlert-icon': {
      color: '#D72B4F',
      alignSelf: 'center',
      marginRight: 10,
    },
  },
}

export default styles
